export const SOLANA_RPC_URL = 'https://purple-practical-friday.solana-mainnet.quiknode.pro/d94ab067f793d48c81354c78c86ae908d9fc1582/';
export const SOLANA_RPC_SUBSCRIPTION_URL = 'wss://api.mainnet-beta.solana.com';
